var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:['tab', { active: _vm.selectedTab === tab.title }],on:{"click":function($event){_vm.selectedTab = tab.title}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_c('div',{staticClass:"tab-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }